import React from "react";
import { cn } from "@/lib/utils";

function FlagSvg({ code }) {
  switch (code) {
    case "he":
      return <><rect width="40" height="28" fill="#fff" /><rect y="3" width="40" height="4" fill="#1554B7" /><rect y="21" width="40" height="4" fill="#1554B7" /><path d="M20 8.2 23.8 15H16.2L20 8.2Zm0 11.6L16.2 13h7.6L20 19.8Z" fill="none" stroke="#1554B7" strokeWidth="1.6" /></>;
    case "es":
      return <><rect width="40" height="28" fill="#AA151B" /><rect y="7" width="40" height="14" fill="#F1BF00" /></>;
    case "it":
      return <><rect width="13.33" height="28" fill="#009246" /><rect x="13.33" width="13.34" height="28" fill="#fff" /><rect x="26.67" width="13.33" height="28" fill="#CE2B37" /></>;
    case "fr":
      return <><rect width="13.33" height="28" fill="#0055A4" /><rect x="13.33" width="13.34" height="28" fill="#fff" /><rect x="26.67" width="13.33" height="28" fill="#EF4135" /></>;
    case "de":
      return <><rect width="40" height="9.33" fill="#000" /><rect y="9.33" width="40" height="9.34" fill="#DD0000" /><rect y="18.67" width="40" height="9.33" fill="#FFCE00" /></>;
    case "pt":
      return <><rect width="16" height="28" fill="#006600" /><rect x="16" width="24" height="28" fill="#FF0000" /><circle cx="16" cy="14" r="4.5" fill="#FFD100" /></>;
    case "ar":
      return <><rect width="40" height="28" fill="#006C35" /><rect x="9" y="12" width="22" height="4" rx="2" fill="#fff" /></>;
    case "el":
      return <><rect width="40" height="28" fill="#0D5EAF" /><g fill="#fff"><rect y="3" width="40" height="3" /><rect y="9" width="40" height="3" /><rect y="15" width="40" height="3" /><rect y="21" width="40" height="3" /><rect width="16" height="16" fill="#0D5EAF" /><rect x="6" width="4" height="16" /><rect y="6" width="16" height="4" /></g></>;
    case "ru":
      return <><rect width="40" height="9.33" fill="#fff" /><rect y="9.33" width="40" height="9.34" fill="#0039A6" /><rect y="18.67" width="40" height="9.33" fill="#D52B1E" /></>;
    case "tr":
      return <><rect width="40" height="28" fill="#E30A17" /><circle cx="16" cy="14" r="7" fill="#fff" /><circle cx="18.5" cy="14" r="5.5" fill="#E30A17" /><path d="M25 14 31 12.1 27.3 17.2v-6.4L31 15.9 25 14Z" fill="#fff" /></>;
    case "zh":
      return <><rect width="40" height="28" fill="#DE2910" /><path d="M8 5.2 9.2 8.6h3.6L9.9 10.7l1.1 3.5L8 12 5 14.2l1.1-3.5-2.9-2.1h3.6L8 5.2Z" fill="#FFDE00" /><circle cx="17" cy="6" r="1.2" fill="#FFDE00" /><circle cx="21" cy="10" r="1.2" fill="#FFDE00" /><circle cx="21" cy="16" r="1.2" fill="#FFDE00" /></>;
    case "en":
    default:
      return <><rect width="40" height="28" fill="#012169" /><path d="M0 0 40 28M40 0 0 28" stroke="#fff" strokeWidth="6" /><path d="M0 0 40 28M40 0 0 28" stroke="#C8102E" strokeWidth="3" /><path d="M20 0v28M0 14h40" stroke="#fff" strokeWidth="10" /><path d="M20 0v28M0 14h40" stroke="#C8102E" strokeWidth="6" /></>;
  }
}

export default function FlagBadge({ code, className }) {
  return (
    <span className={cn("inline-flex shrink-0 overflow-hidden rounded-sm border border-black/10 bg-white shadow-sm", className)} aria-hidden="true">
      <svg viewBox="0 0 40 28" className="h-full w-full" role="img" focusable="false">
        <FlagSvg code={code} />
      </svg>
    </span>
  );
}